// extracted by mini-css-extract-plugin
module.exports = {"component":"SpotifyLink_component__23fn3","link":"SpotifyLink_link__1ueXe","logo":"SpotifyLink_logo__1x3Bu"};